import styleInject from './node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".grecaptcha-badge{left:4px!important;overflow:hidden!important;transition:all .3s ease!important;width:70px!important;z-index:15}.grecaptcha-badge:hover{width:256px!important}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
